import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SptRecorderService} from '@spout/global-web/data-access';

@Component({
  selector: 'spt-help-record-latency-content',
  templateUrl: './help-record-latency-content.component.html',
  styleUrls: ['./help-record-latency-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpRecordLatencyContentComponent {
  constructor(private _recorder: SptRecorderService) {}
  refresh(): void {
    this._recorder.refreshAudioDeviceList().subscribe(() => {});
  }
}
